export const CREATE_ADMIN = {
    REQUEST:"CREATE_ADMIN_REQUEST",
    SUCCESS:"CREATE_ADMIN_SUCCESS",
    FAIL:"CREATE_ADMIN_FAIL",
}

export const GET_ADMIN = {
    REQUEST:"GET_ADMIN_REQUEST",
    SUCCESS:"GET_ADMIN_SUCCESS",
    FAIL:"GET_ADMIN_FAIL",
}

export const GET_ADMINS = {
    REQUEST:"GET_ADMINS_REQUEST",
    SUCCESS:"GET_ADMINS_SUCCESS",
    FAIL:"GET_ADMINS_FAIL",
}

export const UPDATE_ADMIN = {
    REQUEST:"UPDATE_ADMIN_REQUEST",
    SUCCESS:"UPDATE_ADMIN_SUCCESS",
    FAIL:"UPDATE_ADMIN_FAIL",
}

export const DELETE_ADMIN = {
    REQUEST:"DELETE_ADMIN_REQUEST",
    SUCCESS:"DELETE_ADMIN_SUCCESS",
    FAIL:"DELETE_ADMIN_FAIL",
}